import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminPreferencesServices } from '@/modules/preferences/services/admin-preferences.service'
import { PreferenceResourceModel } from '@/modules/preferences/models/preference-resource.model'

@vservice()
export class PreferencesUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly services: AdminPreferencesServices
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(preference: PreferenceResourceModel[]) {
    return this.services.update(preference)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
